module.exports = __webpack_public_path__ + "img/6_Distal-A.6d3e83c3.png";